















import Vue from 'vue';

export default Vue.extend({
  name: '',
  components: {
  },
  // props: {
  //   mode: String,
  // },
  data() {
    return {
    }
  },
  methods: {
  }
})
